import React from 'react';
import ConfirmModal from '../Elements/UI/ConfirmModal';

const Conformationdeleteusermodal = ({ show, onClose, onConfirm }) => {
  return (
    <ConfirmModal
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete user?"
      message="This user's data will be permanently removed. This can't be undone."
    />
  );
};

export default Conformationdeleteusermodal;
